export const emailPrefix = (email) =>
  email?.includes("@") ? email.split("@")[0] : (email ?? "");

export const getInitials = (str) => {
  if (!str) return "??";
  const name = str.includes("@") ? emailPrefix(str) : str;
  const parts = name
    .trim()
    .split(/[\s.\-_]+/)
    .filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

export const getApplicationTitle = (app, t) =>
  `${app.title} + ${(app.participants ?? []).length - 1}`;

export const resolveParticipantName = (
  participant,
  deletedUserLabel = "Deleted user"
) => {
  if (participant?.is_deleted) return deletedUserLabel;
  if (participant.name) return participant.name;
  const id = participant.id;
  if (id && typeof id === "object") {
    const fname = id.fname || id.firstname || "";
    const lname = id.lname || id.lastname || "";
    const full = `${fname} ${lname}`.trim();
    if (full) return full;
  }
  return emailPrefix(participant.email ?? "");
};
